import * as React from "react";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useContextData } from "../hooks/useContextData";
import ErrorIcon from "@mui/icons-material/Error";

const emails = ["username@gmail.com", "user02@gmail.com"];

export interface SimpleDialogProps {
  open: boolean;
  selectedValue: string;
  onClose: (value: string) => void;
}

function SimpleDialog(props: SimpleDialogProps) {
  const { onClose, selectedValue, open } = props;
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const navigation = useNavigate();
  const { theme } = useContextData();

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value: string) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <List
        sx={{
          pt: 4,
          px: 4,
          pb: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          //   borderRadius: 10,
        }}
        style={{
          backgroundColor: theme === "dark" ? "#5c5f63" : "white",
          color: theme === "dark" ? "#FAFAFA" : undefined,
        }}
      >
        <ErrorIcon fontSize="large" />
        <Typography
          variant="h6"
          sx={{ marginTop: "0px", marginBottom: "16px", fontWeight: 600 }}
        >
          You need tokens
        </Typography>
        <Typography>Buy tokens so you can use this app</Typography>
        <Button
          variant="contained"
          onClick={() => {
            handleClose();
            navigation("/pricing");
          }}
          sx={{
            marginTop: "16px",
            marginBottom: "16px",
            borderRadius: 100,
            width: 270,
          }}
          style={{
            background: "linear-gradient(to right bottom, #006eff, #00b6ff)",
          }}
        >
          Buy tokens
        </Button>
      </List>
    </Dialog>
  );
}

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function NotEnoughTokens({ open, setOpen }: Props) {
  const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  const handleClose = (value: string) => {
    setOpen(false);
    setSelectedValue(value);
  };

  return (
    <div>
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        onClose={handleClose}
      />
    </div>
  );
}
